import {
  faDatabase,
  faEllipsisV, faExternalLink,
} from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import {
  RoundButtonComponent, RoundButtonSize,
} from '~/_shared/baseComponents/buttons/roundButton/roundButton.component';
import { RoundButtonStyle } from '~/_shared/baseComponents/buttons/roundButton/roundButton.styles';
import {
  ContextMenuComponent, ContextMenuDefaultItem, ContextMenuItemCoreComponent,
} from '~/_shared/baseComponents/contextMenu';
import { useTranslation } from '~/_shared/utils/hooks';
import { TooltipPlacement } from '~/_shared/utils/placement.util';

const triggerButtonStyle = ({ isMenuOpen, isTrialMode }: { isMenuOpen: boolean; isTrialMode?: boolean }) =>
  isTrialMode ? RoundButtonStyle.Restricted : isMenuOpen ? RoundButtonStyle.Quaternary : RoundButtonStyle.Primary;

export const ActiveDataLayerContextMenuComponent = ({
  boundaryDisplayName,
  isTrialMode,
  onExport,
  onExportAssignments,
  onSaveAsTemplate,
}: Readonly<{
  boundaryDisplayName: string;
  isTrialMode?: boolean;
  onExport?: () => void;
  onExportAssignments?: () => void;
  onSaveAsTemplate?: () => void;
}>) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [t] = useTranslation();

  return (
    <ContextMenuComponent
      isVisible={isMenuOpen}
      onHide={() => setIsMenuOpen(false)}
      maxWidth={280}
      renderMenuContent={() => (
        <>
          {onSaveAsTemplate && (
            <ContextMenuItemCoreComponent>
              <ContextMenuDefaultItem
                icon={faDatabase}
                onClick={onSaveAsTemplate}
                size="s"
              >
                {t('Save as a Template')}
              </ContextMenuDefaultItem>
            </ContextMenuItemCoreComponent>
          )}

          {onExport && (
            <ContextMenuItemCoreComponent>
              <ContextMenuDefaultItem
                icon={faExternalLink}
                onClick={onExport}
                size="s"
              >
                {t('Export Data with Boundaries')}
              </ContextMenuDefaultItem>
            </ContextMenuItemCoreComponent>
          )}

          {onExportAssignments && (
            <ContextMenuItemCoreComponent>
              <ContextMenuDefaultItem
                icon={faExternalLink}
                onClick={onExportAssignments}
                size="s"
                tooltipLabel={t('Export{{what}}', { what: boundaryDisplayName })}
                tooltipPlacement={TooltipPlacement.Right}
              >
                {t('boundaryTool.export.assignments.label')}
              </ContextMenuDefaultItem>
            </ContextMenuItemCoreComponent>
          )}
        </>
      )}
    >

      <RoundButtonComponent
        icon={faEllipsisV}
        onClick={isTrialMode ? undefined : () => setIsMenuOpen(true)}
        size={RoundButtonSize.Small}
        buttonStyle={triggerButtonStyle({ isMenuOpen, isTrialMode })}
      />
    </ContextMenuComponent>
  );
};
